import React, { useEffect } from 'react';
import axios from 'axios';
import { useMediaQuery } from 'react-responsive';
import {
  CircularProgress,
  Divider,
  LinearProgress,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import StarOutlineIcon from '@material-ui/icons/StarOutline';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { storeContext } from '../provider/Provider';
import {
  StyledContentTableCell,
  StyledTableHeadCell,
  StyledTableHeadCell2,
  StyledTablePagination,
} from '../../customUI/table/TableStyles';
import useStyles from '../leads/LeadsFullView.style';
import { websiteAnalyticsActions } from '../../store/website-analytics-reducer';
import MobileTitle from '../../customUI/MobileTitle';

const { REACT_APP_FLASK_API_URL } = process.env;

const KeywordsFullView = () => {
  const classes = useStyles();
  let isPhone = false;
  const { state, dispatch } = React.useContext(storeContext);
  if (!state.websiteAnalytics.isTesting) {
    isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  }
  const [tableBodyHeight, setTableBodyHeight] = React.useState(300);
  const [isInternalFetching, setIsInternalFetching] = React.useState(false);

  const updateRows = (page, perPage) => {
    setIsInternalFetching(true);
    if (document.getElementById('tableBody')) {
      setTableBodyHeight(
        document.getElementById('tableBody').clientHeight > 300
          ? document.getElementById('tableBody').clientHeight
          : 300
      );
    }
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/v1/get-avg-keywords-rankings/${state.websiteSwitch.currentWebsite}/all/${page}/${perPage}`
      )
      .then((res) => {
        if (res.data.message !== 'No results') {
          dispatch({
            type: websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_ALL,
            payload: {
              isFetching: false,
              keywordRankings: {
                keywords: res.data.message,
                totalKeywords: res.data.total_count,
              },
            },
          });
        } else {
          dispatch({
            type: websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_ALL,
            payload: {
              isFetching: false,
              keywordRankings: {
                keywords: [],
              },
            },
          });
        }
        setIsInternalFetching(false);
      });
  };

  useEffect(() => {
    dispatch({
      type: websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_ALL,
      payload: {
        isFetching: true,
      },
    });
    updateRows(1, state.websiteAnalytics.keywordRankings.perPage);
  }, []);

  const handleChangePage = (event, newPage) => {
    dispatch({
      type: websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_ALL,
      payload: {
        keywordRankings: {
          currentPage: newPage,
        },
      },
    });
    updateRows(newPage + 1, state.websiteAnalytics.keywordRankings.perPage);
  };
  const handleChangeRowsPerPage = (event) => {
    dispatch({
      type: websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_ALL,
      payload: {
        keywordRankings: {
          perPage: parseInt(event.target.value, 10),
          currentPage: 0,
        },
      },
    });
    updateRows(1, parseInt(event.target.value, 10));
  };

  const handleStar = (keyword) => {
    axios
      .post(
        `${REACT_APP_FLASK_API_URL}/v1/update-starred-keyword/${state.websiteSwitch.currentWebsite}`,
        { keyword }
      )
      .then((res) => {
        dispatch({
          type: websiteAnalyticsActions.WEBSITE_ANALYTICS_STAR,
          payload: {
            keyword: res.data.keyword,
            starred: res.data.starred,
          },
        });
      });
  };

  function sanitise(x) {
    if (Number.isNaN(Number(x)) || x === 0) {
      return '-';
    }
    return x;
  }

  if (state.websiteAnalytics.isFetching) {
    return (
      <LinearProgress
        style={{ width: '100%' }}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    );
  }
  return (
    <>
      {isPhone && <MobileTitle title="Keywords" />}
      <div className={classes.wrapper}>
        <div className={classes.card}>
          <div className={classes.card__wrapper}>
            <div className={classes.card__header}>
              <div className={classes.heading}>All Keywords</div>
            </div>
            {state.websiteAnalytics.keywordRankings.totalKeywords ? (
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableHeadCell> </StyledTableHeadCell>
                    <StyledTableHeadCell>Keyword</StyledTableHeadCell>
                    <StyledTableHeadCell>Position Current Month</StyledTableHeadCell>
                    <StyledTableHeadCell>Position Previous Month</StyledTableHeadCell>
                    <StyledTableHeadCell2>Change</StyledTableHeadCell2>
                  </TableRow>
                </TableHead>
                {!isInternalFetching && (
                  <TableBody id="tableBody">
                    {state.websiteAnalytics.keywordRankings.keywords.map((row) => (
                      <TableRow key={row.keyword}>
                        <StyledContentTableCell component="th" scope="row">
                          {!row.starred ? (
                            <StarOutlineIcon
                              style={{ fontSize: 30, color: '#58595B', cursor: 'pointer' }}
                              onClick={() => {
                                handleStar(row.keyword);
                              }}
                            />
                          ) : (
                            <StarIcon
                              style={{ fontSize: 30, color: '#ffa400', cursor: 'pointer' }}
                              onClick={() => {
                                handleStar(row.keyword);
                              }}
                            />
                          )}
                        </StyledContentTableCell>
                        <StyledContentTableCell component="th" scope="row">
                          {row.keyword}
                        </StyledContentTableCell>
                        <StyledContentTableCell component="th" scope="row">
                          {row.current_month_position}
                        </StyledContentTableCell>
                        <StyledContentTableCell component="th" scope="row">
                          {row.previous_month_position}
                        </StyledContentTableCell>
                        <StyledContentTableCell component="th" scope="row">
                          {row.current_month_position === '-' ||
                          row.previous_month_position === '-' ? (
                            <span>&nbsp;&nbsp;&nbsp;-</span>
                          ) : (
                            <>
                              {row.current_month_position - row.previous_month_position >= 0 ? (
                                <span style={{ color: '#D81F27', fontWeight: 600 }}>
                                  <ArrowDownwardIcon style={{ fontSize: 15 }} />
                                  {sanitise(
                                    Math.abs(
                                      row.current_month_position - row.previous_month_position
                                    )
                                  )}
                                </span>
                              ) : (
                                <span style={{ color: '#5AA600', fontWeight: 600 }}>
                                  <ArrowUpwardIcon style={{ fontSize: 15 }} />
                                  {sanitise(
                                    Math.abs(
                                      row.current_month_position - row.previous_month_position
                                    )
                                  )}
                                </span>
                              )}
                            </>
                          )}
                        </StyledContentTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            ) : (
              <span>No results</span>
            )}
          </div>
          {isInternalFetching && (
            <div className={classes.loading} style={{ height: tableBodyHeight }}>
              <CircularProgress />
            </div>
          )}
          <Divider />
          <div className={classes.card__wrapper}>
            <div className={classes.cardActionButton} aria-hidden="true">
              <StyledTablePagination
                rowsPerPageOptions={[15, 50]}
                component="div"
                count={state.websiteAnalytics.keywordRankings.totalKeywords}
                rowsPerPage={state.websiteAnalytics.keywordRankings.perPage}
                page={state.websiteAnalytics.keywordRankings.currentPage}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KeywordsFullView;
